import { list } from "./list";

export const orderLayouts = { list };
